import React from 'react';
import HoverCard from '../HoverCard/HoverCard';

import meditate from '../../images/meditate.png';
import focusBlocks from '../../images/focus-blocks.svg';
import focusDistractions from '../../images/focus-distractions.svg';
import focusMusic from '../../images/focus-music.png';
import arrow from '../../images/arrow-curly.svg';
import './Focus.scss';

const Focus = () => (
  <div className="focus">
    <div className="focus-top container">
      <div className="col col-6 flex justify-center">
        <img src={meditate} alt="" />
      </div>
      <div className="focus-content col col-6 flex flex-col justify-center">
        <h2 className="text-gradient">Be in the zone.</h2>
        <h2>Stay focused with ease.</h2>
        <img className="arrow hidden-mobile" src={arrow} alt="" />
      </div>
    </div>
    <div className="cards container">
      <HoverCard title="Snooze distractions" image={focusBlocks}>
        <p>Configure Slack to snooze notifications when you're in focus</p>
        <p>
          Your team will know what you're busy with (based on your privacy
          settings).
        </p>
      </HoverCard>
      <HoverCard title="Proactive focus blocks" image={focusDistractions}>
        <p>
          Block preferred timeslots in advance to keep your calendar available
          for deep work.
        </p>
      </HoverCard>
      <HoverCard title="Focus" image={focusMusic}>
        <p>Fresh playlists every week for different tasks</p>

        <p>
          Lyric free music for deep work and the latest coffee shop music for
          everything else.
        </p>
      </HoverCard>
    </div>
  </div>
);

export default Focus;
